"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const locale_key_enum_1 = require("enums/locale-key.enum");
const Button_1 = __importDefault(require("components/design-system/Button"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const UnderMaintenance = () => {
    return (react_1.default.createElement("div", { className: "flex h-[100vh] w-[100vw] flex-col items-center justify-center gap-[24px] overflow-hidden bg-n-000 px-[64px]" },
        react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-under-construction", width: 146 }),
        react_1.default.createElement("div", { className: "flex max-w-[400px] flex-col items-center gap-[12px]" },
            react_1.default.createElement("p", { className: "typography-h700 leading-[40px] text-n-900" }, locale_key_enum_1.LocaleKey.well_be_back_soon.h5locale().capitalize()),
            react_1.default.createElement("p", { className: "typography-h400 text-center leading-[24px] text-n-800" }, locale_key_enum_1.LocaleKey.happy5_is_currently_under_maintenance_we_apologize_for_the_inconvenience_and_appreciate_your_patience
                .h5locale()
                .capitalizeSentences())),
        react_1.default.createElement(Button_1.default, { onClick: () => window.location.reload(), id: "maintenance-refresh-button" }, locale_key_enum_1.LocaleKey.refresh.h5locale().capitalize())));
};
exports.default = UnderMaintenance;
